module.exports = __webpack_public_path__ + "static/media/BLUSH_6700.872fd823.jpg";